import { useContext, useState, useEffect } from "react";
import { CurrencyContext } from "contexts/currency";
import Button from "components/ui/buttons/Button/Button";

import styles from "./ExperienceFooterBar.module.scss";

export default function ExperienceFooterBar({
  onClick,
  buttonRef,
  experience,
  isAddingToCart,
}) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const position = window.pageYOffset;

      position > windowHeight / 1.7 ? setShow(true) : setShow(false);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const currency = useContext(CurrencyContext).currency;
  const currencies = experience?.metadata?.currencies;

  return (
    <div
      className={`${styles.experienceFooterBar} ${
        show ? styles.show : styles.hide
      }`}
    >
      <div className={`${styles.info}`}>
        <div className={`${styles.price}`}>
          <span className={`${styles.amount}`}>{`${currency.symbol}${
            currencies[currency.code]
          }`}</span>
          <span className={`${styles.timeUnit}`}>/week</span>
        </div>
      </div>
      <div className={`${styles.buttonContainer}`} ref={buttonRef}>
        <div className={`${styles.buttonWrapper}`}>
          <Button
            classes={["checkoutButton"]}
            fill="bright"
            type="button"
            onClick={onClick}
            loading={isAddingToCart}
          >
            Add to Cart
          </Button>
        </div>
      </div>
    </div>
  );
}
